<template>
  <span>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>آیدی:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.id }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>نام:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.first_name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>نام خانوادگی:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.last_name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>نام کاربری:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.username }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>شماره تلفن:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.phone }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>تاریخ عضویت:</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.created_at }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>دعوت شده توسط: (ایدی / اسم / شماره تلفن)</v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.referred_by }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>تعداد کاربران زیرمجموعه: </v-list-item-title>
          <v-list-item-subtitle>{{ userInfo.referrals.length  }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </span>
</template>

<script>
export default {
  props: {
    userInfo: {},
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {},
};
</script>
